/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2643__part-0
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_54 from /* 54 */"../../../54"
import * as /* [auto-meaningful-name] */Module_19 from /* 19 */"../../../19"
import /* 0 */"react"
import * as /* [auto-meaningful-name] */React from "react"
import /* [auto-meaningful-name] */React1 from /* 0 */"react"
var s = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function (e) {
  return typeof e
} : function (e) {
  return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
}
var c = "object" === ("undefined" === typeof window ? "undefined" : s(window)) && "object" === ("undefined" === typeof document ? "undefined" : s(document)) && 9 === document.nodeType
export { c }
